import { useState } from "react";
import { TwoFALogin } from "features/auth/TwoFALogin";
import {
  LoginChallenge,
  LoginRequest,
  LoginResponse,
  OAuthUserRequest,
} from "@shared/types";
import NewIpLogin from "features/auth/NewIpLogin";
import LoginForm from "features/auth/LoginForm";

const LoginPage = () => {
  const [loginDetails, setLoginDetails] = useState<
    LoginRequest | OAuthUserRequest | undefined
  >();
  const [loginResponse, setLoginResponse] = useState<
    LoginResponse | undefined
  >();

  if (loginDetails) {
    if (loginResponse?.challenge === LoginChallenge.TWO_FA) {
      return <TwoFALogin loginDetails={loginDetails} />;
    } else if (loginResponse?.challenge === LoginChallenge.NEW_IP) {
      return <NewIpLogin loginDetails={loginDetails} />;
    }
  }

  return (
    <LoginForm
      onSuccessfulLogin={(args: LoginRequest | OAuthUserRequest) =>
        setLoginDetails(args)
      }
      setLoginResponse={setLoginResponse}
    />
  );
};

export default LoginPage;
